<template lang="pug">
  .loading-wrapper
    router-view
    transition(name="fade" mode="out-in")
      .loading(v-if="loading")
        v-progress-circular.progress(:size=100 indeterminate)
</template>

<script>
export default {
  data: () => ({
    loading: false
  }),
  name: 'App'
}
</script>

<style lang="sass">
  @import "sass/main"
  .fade-enter-active, .fade-leave-active
    transition: opacity .5s
  .fade-enter, .fade-leave-to
    opacity: 0
  .loading-wrapper
    position: relative
    .loading
      position: absolute
      top: 0
      bottom: 0
      left: 0
      right: 0
      background-color: #fafafa
      .progress
        position: fixed
        margin: auto
        left: 0
        right: 0
        bottom: 0
        top: 0
</style>



// WEBPACK FOOTER //
// src/App.vue